import { useEffect, useRef } from "react";
import { publishedDateFormat3 } from "@/utils/dateTimeFormat";
import { processTwitterEmbeds, processInstagramEmbeds } from "@/utils/socialEmbeds";

const LiveBlog = ({
  id=null,
  liveEvent,
  isMadhya = false,
  isRajasthan = false,
  isHR = false,
  isUP = false,
  isBH = false,
  isCGH = false,
  isUK = false,
  isBiz=false,
  isPB=false
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const description = liveEvent?.description || "";
    const hasTwitter =
      description.includes("twitter-tweet") ||
      description.includes("platform.twitter.com") || description?.includes("platform.x.com");
    const hasInsta =
      description.includes("instagram-media") ||
      description.includes("instagram.com/embed.js");

    if (hasTwitter) processTwitterEmbeds(containerRef.current);
    if (hasInsta) processInstagramEmbeds();
  }, [liveEvent?.id, liveEvent?.description]);

  return (
    <li className="border" key={liveEvent?.id} id={id} ref={containerRef}>
      <div className="w-full h-full relative px-4 py-2">
        <div className="text-zinc-500 text-base font-light">
          {publishedDateFormat3(liveEvent?.datetime_updated)}
        </div>
        <h2
          className="text-black text-lg font-semibold leading-relaxed"
          dangerouslySetInnerHTML={{ __html: `${liveEvent?.title}` }}
        />
        <div
          className="text-black text-lg font-light leading-[25.20px] break-words"
          dangerouslySetInnerHTML={{ __html: `${liveEvent?.description}` }}
        />
        <div className="w-[4.40px] h-[3.67px] left-[85.42px] top-[10.31px] absolute origin-top-left rotate-90 bg-stone-300 bg-opacity-50 rounded-full"></div>
        <div className="w-px h-[19px] left-[0.50px] top-[10px] absolute flex-col justify-center items-center gap-2.5 inline-flex">
          <div
            className={`w-2.5 h-2.5 origin-top-left ${
              isMadhya
                ? "bg-[#0C8A70]"
                : isRajasthan
                ? "bg-[#FFA51A]"
                : isHR
                ? "bg-[#64BC46]"
                : isBH
                ? "bg-[#CF4C9B]"
                : isUP
                ? "bg-[#f6523e]"
                : isCGH
                ? "bg-[#0C8A70]"
                : isUK
                ? "bg-ukDark"
                : isBiz
                ? "bg-bizDark"
                : isPB
                ? "bg-pbDark"
                : "bg-primary"
            } rounded-full`}
          ></div>
        </div>
      </div>
    </li>
  );
};

export default LiveBlog;
